import _flatten from 'lodash/flatten';

export const getLessonsCount = (course: any, lesson: any) => {
  const lessons = course.lessons
    ? course.lessons
    : _flatten(course.modules.map((module: any) => module.lessons));
  const lessonIndex = lessons.findIndex(
    (courseLesson: any) => courseLesson.id === lesson.id,
  );
  return {
    totalLessons: lessons.length,
    lessonIndex: lessonIndex + 1,
  };
};
